import React from 'react';
import './popup.css';

export const PopUp = ({ message, isSuccess, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className={`popup-box ${isSuccess ? 'success' : 'error'}`}>
        <h3>{isSuccess ? 'Success' : 'Error'}</h3>
        <p>{message}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};
